module.exports = __webpack_public_path__ + "img/abc_hi.7aba4fca.jpg";